import React from "react";


function Contact() {
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/9.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>

        <div className="row">
          <div className="col-md-5" style={{ background: '#ffffffff', padding: '50px' }}>
            <div className="row" style={{ borderBottom: '0px solid orange', paddingBottom: '15px', paddingTop: '15px' }}>
              <h3 className="cheading" >Address</h3>
              {/* first */}
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">Borivali Sree Ayyappa Temple,  <br />
                    Sree Ayyappa Seva Sangham – Saibaba Nagar (Regd.) <br />
                    Temple Complex, Ram Nagar, <br />
                    Borivali West, Mumbai – 400092</p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">+91 98698 31929</p>
                </div>
              </div>
              <div class="row" style={{ borderBottom: '1px solid orange', paddingBottom: '15px', marginBottom: '15px', width: '100%' }}>
                <div className="col-md-1 middle">
                  <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                </div>
                <div className="col-md-10 ">
                  <p className="addr">ayyappatempleborivli@gmail.com</p>
                </div>
              </div>

            </div>
          </div>
          <div className="col-md-7" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7937311.585040736!2d70.20736330917904!3d13.740206638127278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6d543c17b55%3A0xafba2360102e9887!2sShri%20Ayyappa%20Swamy%20Temple%20(Borivali)!5e0!3m2!1sen!2sin!4v1775213610952!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>



          </div>
        </div>


      </div>
    </div>
  );
}

export default Contact;
